module.exports = __webpack_public_path__ + "img/logo_10_hover.04c0d685.png";